import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {VisualWorkspaceLens} from '../../../../models/api/visualWorkspaceModel';
import {InboxesFiltersEnum} from '../../../../models/url/inboxesUrlModel';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
  WorkspaceDisplayChevronActionsEnum,
  WorkspaceDisplayChevronSectionsEnum,
} from '../../../../services/tracking';
import {AppState} from '../../../../store/appState';
import {toggleExpandItemAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {
  getShouldAlphabetizeWorkspace,
  getShouldUseOpenFilterForTeams,
} from '../../../../store/data/preferences/preferencesSelectors';
import {
  getIsUserGlobalAdmin,
  getUserId,
  getUserLicenseType,
  getUserNamespace,
} from '../../../../store/data/teammates/teammatesSelectors';
import {makeGetVisualWorkspaceLenses} from '../../../../store/data/workspace/visualWorkspace/visualWorkspaceSelectors';
import {
  defaultIsLensesWorkspaceExpanded,
  lensesWorkspaceExpandedKey,
  makeGetIsLensesWorkspaceExpanded,
} from '../../../../store/data/workspace/workspaceExpandedSelectors';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {LensesWorkspace} from './lensesWorkspace';

/*
 * Props.
 */

interface LensesWorkspaceContainerProps {
  visualWorkspaceLenses: ReadonlyArray<VisualWorkspaceLens>;
}

/*
 * Selectors.
 */

function getVisualWorkspaceLenses(_state: AppState, props: LensesWorkspaceContainerProps) {
  return props.visualWorkspaceLenses;
}

const getDefaultStatusFilter = createSelector(
  [getShouldUseOpenFilterForTeams],
  (shouldUseOpenFilterForTeams) =>
    shouldUseOpenFilterForTeams
      ? (InboxesFiltersEnum.OPEN as const)
      : (InboxesFiltersEnum.UNASSIGNED as const),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<LensesWorkspaceContainerProps>()(() => ({
  lenses: makeGetVisualWorkspaceLenses(getVisualWorkspaceLenses),
  userId: getUserId,
  userNamespace: getUserNamespace,
  userLicenseType: getUserLicenseType,
  isUserGlobalAdmin: getIsUserGlobalAdmin,
  isExpanded: makeGetIsLensesWorkspaceExpanded(),
  shouldAlphabetizeWorkspace: getShouldAlphabetizeWorkspace,
  defaultStatusFilter: getDefaultStatusFilter,
}));

export const LensesWorkspaceContainer = connect(
  mapStateToProps,
  {toggleExpandItemAction, navigateToLinkAction},
  (stateProps, dispatchProps, ownProps) => {
    const onToggleExpandClick = () => {
      trackInterfaceEvent(InterfaceEventsEnum.P1_WORKSPACE_CHEVRON_CLICK, {
        location: WorkspaceDisplayChevronSectionsEnum.LENSES,
        action: stateProps.isExpanded
          ? WorkspaceDisplayChevronActionsEnum.COLLAPSE
          : WorkspaceDisplayChevronActionsEnum.EXPAND,
      });
      dispatchProps.toggleExpandItemAction(lensesWorkspaceExpandedKey, defaultIsLensesWorkspaceExpanded);
    };

    // Merge the props.
    return {
      ...stateProps,
      ...ownProps,
      onToggleExpandClick,
    };
  },
)(LensesWorkspace);
